/**
 * One world buffer's screen-space ambient occlusion, which lives as long as the buffer: its buffers,
 * shaped by the frame and the project's settings (`ss_effects.cpp:1098-1128`).
 */
import { beginStep, endStep } from '../frameProfile/frameProfile.js';
import { leaveSlot } from '../sharedTexture.js';
import { FittedBuffers } from '../screenSpaceEffects/fittedBuffers.js';
import { OcclusionBuffers } from './occlusionBuffers.js';
import { generateOcclusion } from './occlusionPasses.js';
import { occlusionSlot } from './ssaoUniforms.js';
export class WorldOcclusion {
    buffers = new FittedBuffers((_renderer, shape) => new OcclusionBuffers(shape), (renderer, buffers) => leaveSlot(renderer, occlusionSlot, buffers.occlusion.texture));
    /** The occlusion of the last generation, as the colour pass reads it. Null before the first. */
    get occlusion() {
        return this.buffers.current?.occlusion.texture ?? null;
    }
    /** Draws the occlusion of the frame `prepass` holds, seen through `camera`, at `settings`. */
    generate(renderer, prepass, camera, { ssao, project }) {
        const { width, height } = prepass.shape;
        const { quality, isHalfSize, ssilQuality, isSsilHalfSize } = project;
        const shaping = { quality, isHalfSize, ssilQuality, isSsilHalfSize };
        const buffers = this.buffers.fit(renderer, { width, height, project: shaping });
        beginStep(renderer, 'Screen-space ambient occlusion');
        generateOcclusion(renderer, prepass, buffers, { projection: camera.projectionMatrix, ssao, project });
        endStep(renderer, 'Screen-space ambient occlusion');
    }
    release(renderer) {
        this.buffers.release(renderer);
    }
}
//# sourceMappingURL=worldOcclusion.js.map